import React from 'react'
import { Provider } from 'react-redux'
import store from '../../redux/store'
import Router from './router'
import '../../utils/font/font'
import FullStory from 'react-fullstory'

const App = () => {
	return (
		<>
			<FullStory org={process.env.REACT_APP_FULLSTORY_ORG_ID} />
			<Provider store={store}>
				<Router />
			</Provider>
		</>
	)
}

export default App
